import styled from "styled-components";

import { BackgroundColorGray } from "ds/Alias/src/tokens";
import { Button } from "ds/Button";
import { Space50, Space150 } from "ds/Core";

export const StyledTooltipContainer = styled.div`
  position: relative;
  width: 232px;
  display: flex;
  flex-direction: column;
  gap: ${Space50};
  background-color: ${BackgroundColorGray};
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  right: ${Space150};
  top: ${Space150};
`;
